import React from "react";
import AnimatedText from "../Components/animation/text/AnimatedText";
import ImageShowdown from "../Components/animation/images/ImageShowdown";
import EmojiDisplay from "../Components/animation/emojis/EmojiDisplay";
import { faYoutube, faGithub, faGooglePlay, faItchIo } from '@fortawesome/free-brands-svg-icons'
import SkillBadge from "../Components/SkillBadge";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FIRE_MAN = { key: "1f98b", value: "" };

const images = [
    {
        key: "1", path: "./Projects/Lathos.png", clickables: [
            { link: "https://www.youtube.com/watch?v=E3ERIm5eLmU", icon: faYoutube, color: "red" },
            { link: "https://up202004891.itch.io/chronicles-of-dasos", icon: faItchIo, color: "#fefefe" },
        ]
    },
    {
        key: "2", path: "./Projects/memento.png", clickables: [
            { link: "https://play.google.com/store/apps/details?id=pt.memento", icon: faGooglePlay, color: "#33ff33" },
        ]
    },
    {
        key: "4", path: "./Projects/SDLE.png", clickables: [
            { link: "https://www.youtube.com/watch?v=pQyYa4NAPMU", icon: faYoutube, color: "red" },
            { link: "https://github.com/Rica320/shopping-list", icon: faGithub, color: "#2b2e30" },
        ]
    },
    {
        key: "3", path: "./Projects/genesys_chat.png", clickables: [
            { link: "https://www.youtube.com/watch?v=kdXjqf8CaZo", icon: faYoutube, color: "red" },
        ]
    },
    {
        key: "5", path: "./Projects/nexus.png", clickables: [
            { link: "https://www.youtube.com/watch?v=RDeHB1bAYVA", icon: faYoutube, color: "red" },
            { link: "https://github.com/Rica320/Nexus-Social-Network", icon: faGithub, color: "#2b2e30" },
        ]
    },
    {
        key: "6", path: "./Projects/ai-space.png", clickables: [
            { link: "https://github.com/Rica320/ia_t1", icon: faGithub, color: "#fefefe" },
        ]
    },
    

];

const Projects = () => {

    return (
        <div id="projects" className="relative w-full flex flex-col items-center justify-center overflow-hidden mt-10">
            <div className="w-full xl:w-[70%] flex flex-row pb-16">
                <div className="w-full">
                    <AnimatedText text="Projects" />

                    <p className="text-secondary-400 text-[18px] mt-5 ml-12">
                        This is a selection of projects I've contributed to, as well as some of my
                        <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700"> personal projects. </span>
                    </p>

                </div>

            </div>
            <div className="absolute top-6 right-10 mt-18 mr-36">
                <EmojiDisplay selectedEmoji={FIRE_MAN} />
            </div>
            <ImageShowdown images={images} />
            

            <div className="mt-12 flex justify-center pb-3">
                <motion.a
                    href="https://www.youtube.com/@Rica320"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-green-600 text-primary-400 px-4 py-2 rounded-full border-2 border-green-700 select-none shadow-md"
                    whileHover={{
                        scale: 1.05,
                        boxShadow: "0 3px 15px rgba(0,0,0,0.1)",
                    }}
                    whileTap={{ scale: 0.95 }}
                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                >
                    <FontAwesomeIcon icon={faYoutube} className="w-5 h-5 text-red-600" />
                    <span>See more on YouTube</span>
                </motion.a>
            </div>


        </div>
    );

}

export default Projects;
